import Task from "../../../lib/html5-software-library/src/ranj/util/executor/Task";
import GoogleAnalyticsEvent from "./GoogleAnalyticsEvent";

export default class InitGoogleAnalyticsTask extends Task {

    /**
     * Task to load and initialize GoogleAnalytics
     * @param {soma.EventDispatcher} dispatcher - the soma EventDispatcher
     */
    constructor(dispatcher, config) {
        super();
        this._dispatcher = dispatcher;
        this._config = config;
    }

    execute(callback, progressCallback) {
        this._loadGoogleAnalytics(callback);
    }

    _loadGoogleAnalytics(callback) {
        const script = document.createElement("script");
        document.getElementsByTagName('body')[0].appendChild(script);
        script.onload = () => {
            window.ga = window.ga || function() { (ga.q = ga.q || []).push(arguments) }; ga.l = +new Date;
            //start session
            this._dispatcher.dispatch(GoogleAnalyticsEvent.INIT);
            //Task complete:
            callback(this);
        }
        script.src = 'https://www.google-analytics.com/analytics.js';
    }
}